import React, { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import _ from "lodash";
import SentiTextarea from "./components/senti-textarea";
import ToolTip from "./components/tooltip";
import analyze from "./lib/analyze";
import { getScoreColor } from "./util/score";

const ComposerContainer = styled.div`
  background-color: tranparent;
  padding: 0;
  height: 100%;
  margin: auto;
  width: 100%;
  max-width: 400px;
`;

const TextareaContainer = styled.div`
  display: flex;
  margin: 0px;
  padding: 0px;
  border: 0px;
  border-left: 0;
`;

const Label = styled.label``;

const Sidebar = styled.div`
  background-color: ${({ sidebarColor }) => sidebarColor};
  width: 8px;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;

export default function Sentitext(props) {
  const { labeltext, name, placeholder, sidebarColors, textareaId } = props;
  const [debouncedText, setDebouncedText] = useState("");
  const [toolTipsVisible, setToolTipsVisible] = useState(false);
  const [sentimentResult, setSentimentResult] = useState({
    score: 0,
    positiveWords: {},
    negativeWords: {},
  });

  const setText = _.debounce(setDebouncedText, 200);
  /* eslint-disable-next-line */
  const handleChange = useCallback((e) => {
    const { target } = e;
    setText(target.value);
  });

  function toggleToolTip() {
    setToolTipsVisible(!toolTipsVisible);
  }

  useEffect(() => setSentimentResult(analyze(debouncedText)), [debouncedText]);

  return (
    <ComposerContainer>
      <Label htmlFor={textareaId}>{labeltext}</Label>
      <TextareaContainer>
        <ToolTip
          words={{
            positive: sentimentResult.positiveWords,
            negative: sentimentResult.negativeWords,
          }}
          score={sentimentResult.score}
          visible={toolTipsVisible}
        />
        <Sidebar
          sidebarColor={getScoreColor(sentimentResult.score, sidebarColors)}
          visible={true}
          onClick={toggleToolTip}
        />
        <SentiTextarea
          handleChange={handleChange}
          name={name}
          placeholder={placeholder}
          textareaId={textareaId}
        />
      </TextareaContainer>
    </ComposerContainer>
  );
}

Sentitext.propTypes = {
  labeltext: PropTypes.string,
  name: PropTypes.string,
  placeholderText: PropTypes.string,
  sidebarColors: PropTypes.shape({
    warn: PropTypes.string,
    success: PropTypes.string,
    neutral: PropTypes.string,
  }),

  textareaId: PropTypes.string,
  toolTipStyle: PropTypes.shape({
    visible: PropTypes.bool,
  }),
};

Sentitext.defaultProps = {
  labeltext: null,
  name: "textarea",
  placeholder: "Type your text here.",
  sidebarColors: {
    warn: "rgba(255, 149, 0, 1)",
    success: "rgba(52, 199, 89, 1)",
    neutral: "rgba(142, 142, 147, 1)",
  },
  textareaId: "textarea",
  toolTipStyle: {
    active: true,
    visible: false,
  },
};


